import components from '../components'
import parsers from '../parsers'
import alias from './alias'
import manager from './manager'
import FormCreateFactory from '@form-create/core/src/index'
import makers from './maker'
import '../style.css'
import extendApi from './api'
import required from './provider'
import { registerZorynComponents } from '../register-z'

function install(FormCreate) {
  FormCreate.componentAlias(alias)
  registerZorynComponents(FormCreate)

  components.forEach((component) => {
    FormCreate.component(component.name, component)
  })

  FormCreate.register(required)

  parsers.forEach((parser) => {
    FormCreate.parser(parser)
  })

  Object.keys(makers).forEach((name) => {
    FormCreate.maker[name] = makers[name]
  })
}

export default function zorynFormCreate() {
  return FormCreateFactory({
    ui: 'zoryn',
    version: '3.3.3',
    manager,
    extendApi,
    install,
    attrs: {
      normal: ['col', 'wrap'],
      array: ['className'],
      key: ['title', 'info'],
    },
  })
}
